import { createSvgIcon } from "@mui/material";

export const UpDownChevronIcon = createSvgIcon(
  <svg viewBox="0 0 7 10" fill="none">
    <path
      fill="currentColor"
      d="M3.26301 1.56822L3.66235 1.10231L3.26301 0.76001L2.86366 1.10231L3.26301 1.56822ZM3.26301 8.93185L2.86366 9.39776L3.26301 9.74006L3.66235 9.39776L3.26301 8.93185ZM0.798704 4.48867L3.66235 2.03412L2.86366 1.10231L0 3.55686L0.798704 4.48867ZM2.86366 2.03412L5.72731 4.48867L6.52601 3.55686L3.66235 1.10231L2.86366 2.03412ZM0 6.94321L2.86366 9.39776L3.66235 8.46595L0.798704 6.0114L0 6.94321ZM3.66235 9.39776L6.52601 6.94321L5.72731 6.0114L2.86366 8.46595L3.66235 9.39776Z"
    />
  </svg>,
  "UpDownChevronIcon",
);
